<template>
  <div class="site">
    <!-- <button @click="cc">qqq</button> -->
    <!-- <div class="mutation-list">
      <h1 @click="geneClick(siteData)">EGFR</h1>
      <div class="show-box"></div>
      <div class="data-box">
        <div class="left">
          <div>
            <p>核苷酸</p>
            <h2>c.2732>G</h2>
          </div>
          <div>
            <p>突变类型</p>
            <h2>突变</h2>
          </div>
          <div>
            <p>染色体</p>
            <h2>Chr7</h2>
          </div>
          <div>
            <p>转录本</p>
            <h2>NM_0024242.3</h2>
          </div>
         
        </div>
        <div class="right">
          <div>
            <p>氨基酸</p>
            <h3 @click="wdClick(siteData)">p.L8523R</h3>
          </div>
          <div>
            <p>频率</p>
            <h2>8.5%</h2>
          </div>
          <div>
            <p>外显子</p>
            <h2>21/28</h2>
          </div>
          <div>
            <p>变异等级</p>
            <h3 @click="byClick(siteData)">I类</h3>
          </div>
          
        </div>
      </div>
    </div> -->
    <div class="box">
      <h1>位点注释</h1>
      <div class="show-box"></div>
      <div class="text" v-html="siteData.siteAnnotation">
        <!-- {{siteData.siteAnnotation}} -->
      </div>
    </div>
    <div class="box">
      <h1>位点解析</h1>
      <div class="show-box"></div>
      <div class="text" v-html="siteData.siteAnalysis"></div>
    </div>
    <div class="box">
      <h1>基因描述</h1>
      <div class="show-box"></div>
      <div class="text" v-html="siteData.geneDesc"></div>
    </div>
    <div class="box">
      <h1>潜在获益药物</h1>
      <div class="show-box"></div>
      <div class="text">
        {{ siteData.fdaNmpaDrugs }}
      </div>
    </div>
    <div class="box">
      <h1>FDA/NMPA批准适应症</h1>
      <div class="show-box"></div>
      <div class="text">
        {{ siteData.fdaNmpaRatifyAdaptation }}
      </div>
    </div>
    <div class="box">
      <h1>NCCN指南推荐</h1>
      <div class="show-box"></div>
      <div class="text">
        {{ siteData.nccnRecommend }}
      </div>
    </div>
    <div class="box">
      <h1>临床试验/回顾性分析</h1>
      <div class="show-box"></div>
      <div class="text" v-html="siteData.clinical"></div>
    </div>
  </div>
</template>

<script>
import { findAnalysis } from "@/api/wxapi.js";

export default {
  data() {
    return {
      siteData: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    cc() {
      let str = "TP53-p.Arg175His";
      let par = encodeURI(str).replace(/\+/g, "%2B");
      this.$router.push({
        path: "wx/siteJiedu",
        query: {
          sessionId: this.$route.query.sessionId,
          fname: this.$route.query.fname,
          fid: this.$route.query.fid,
          site: par,
        },
      });
    },
    getData() {
      findAnalysis({
        geneName: decodeURIComponent(this.$route.query.site),
        labOriginalSampleNo: this.$route.query.fname,
        productCode: this.$route.query.fid,
      }).then((res) => {
        this.siteData = res.data[0];
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ i {
  font-style: normal;
}
.site {
  padding: 20px 16px;
  .box {
    border-radius: 10px;
    background: @background_color;
    margin-bottom: 20px;
    h1 {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2f354d;
      line-height: 70px;
      padding-left: 24px;
    }
    .text {
      padding: 10px 24px 20px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5f697d;
      line-height: 30px;
      word-break: break-all;
      text-align: justify;
      text-justify: newspaper;
    }
  }
}
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.1) 100%
  );
}
.mutation-list {
  height: auto;
  padding-bottom: 10px;
  background: @background_color;
  // box-shadow: 0px 10px 20px -4px rgba(52, 68, 132, 0.16);
  border-radius: 10px;
  margin-bottom: 20px;

  .data-box {
    display: flex;
    padding-left: 24px;
    padding-top: 10px;

    .left {
      flex: 1;

      & > div {
        margin-bottom: 20px;
      }
    }

    .right {
      flex: 1;

      & > div {
        margin-bottom: 20px;
      }
    }

    h2 {
      font-size: 13px;
      font-family: @family;
      font-weight: 500;
      color: #2f354d;
      line-height: 18px;
    }

    p {
      font-size: 12px;
      font-family: @family;
      font-weight: 400;
      color: #a4a9bf;
      line-height: 17px;
      margin-bottom: 4px;
    }

    h3 {
      font-size: 13px;
      font-family: @family;
      font-weight: 500;
      color: #4b84ff;
      line-height: 18px;
    }

    h4 {
      font-size: 13px;
      font-family: @family;
      font-weight: 500;
      color: #27ca8d;
      line-height: 18px;
    }
  }

  h1 {
    height: 70px;
    line-height: 70px;
    position: relative;
    font-size: 18px;
    font-family: @family;
    font-weight: 500;
    color: #4b84ff;
    text-indent: 24px;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -7px;
      width: 3px;
      height: 14px;
      background: #4b84ff;
      border-radius: 0px 2px 2px 0px;
    }
  }
}
</style>